import React from 'react';

const LoadingComponent = () => {
    return (
        <div className="h-4/6 flex justify-center items-center">
            <div className="loader"></div>
        </div>
    );
};

export default LoadingComponent;